import { useTranslation } from "react-i18next";

export function useI18nReady(): boolean {
  const { i18n } = useTranslation();
  return i18n.isInitialized && i18n.hasLoadedNamespace("translation");
}
